import { render } from "./ClientProjectsTable.vue?vue&type=template&id=2d0ec30c"
import script from "./ClientProjectsTable.vue?vue&type=script&lang=js"
export * from "./ClientProjectsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__